import * as yup from "yup";

export const SIGN_IN_SCHEMA = yup.object({
  email: yup.string().email().required("pages.login.schema.email.required"),
  password: yup.string().required("pages.login.schema.password.required"),
});

export type SignInFormState = yup.InferType<typeof SIGN_IN_SCHEMA>;
